//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/PcbExchange.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../no/Expression.js";
let d=[[[0,"AssemblyUpdateOptions",1,0],[0,"BoardFile",1,0],[0,"BoardFolder",1,0],[1,"BoardThickness",0,"Expression",0],[0,"BoardUpdateOptions",1,0],[0,"CompareOptions",1,0],[0,"ECADEntityFilter",1,"PcbExchange.EntityFilter",0],[0,"EcadLocation",1,0],[0,"EcadNumber",1,0],[0,"EcadRevision",1,0],[0,"FilterEcadModel",1,0],[0,"FilterNxModel",1,0],[0,"FromOdbFolder",1,0],[0,"LibraryFile",1,0],[0,"NXEntityFilter",1,"PcbExchange.EntityFilter",0],[0,"OnlyUseExistingComponents",1,0],[0,"OverrideBoardThickness",1,0],[0,"ShowLog",1,0],[0,"UseCurrentWorkPart",1,0]],[[[],"Compare",{},0,0],[["resDef","status"],"SetUpdateOption",{},2,0],[[],"PreviewChanges",{},0,0],[[],"UnhighlightAll",{},0,0]],[]];
SPLM.PcbExchange.CompareAndUpdateBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.PcbExchange.CompareAndUpdateBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.PcbExchange.CompareAndUpdateBuilder.EcadLocationEnum = Object.freeze({
    "Local" : "Local", "Teamcenter" : "Teamcenter"});

SPLM.PcbExchange.CompareAndUpdateBuilder.CompareEnum = Object.freeze({
    "All" : "All", "BoardOnly" : "BoardOnly"});

SPLM.PcbExchange.CompareAndUpdateBuilder.BoardUpdateEnum = Object.freeze({
    "All" : "All", "None" : "None"});

SPLM.PcbExchange.CompareAndUpdateBuilder.AssemblyUpdateEnum = Object.freeze({
    "All" : "All", "None" : "None", "Specify" : "Specify"});

export default SPLM;